import { SectionContainer, SectionContent } from 'builder/components/ProfileSummary/styles'
import RichTextArea from 'builder/components/RichTextArea/RichTextArea'
import {
  SectionBodyFoldableContainer,
  SectionHeader,
  SectionHeaderFoldableContainer,
  SectionHint,
  useFoldableSectionHandlers,
} from 'builder/components/Section'
import SectionTitle from 'builder/components/SectionTitle'
import { useUpdateSimpleShokomuField } from 'builder/hooks/useUpdateSimpleShokumuField'
import { SectionNames } from 'builder/modules/resumeEditor'
import { useShokumuTranslations } from '../../useShokumuTranslations'

export const JobSummary = (): JSX.Element => {
  const { fieldValue, updateField } = useUpdateSimpleShokomuField('profile')
  const { i18n } = useShokumuTranslations()
  const title = i18n('work_summary.title')
  const hint = i18n('work_summary.hint')
  const tip = i18n('work_summary.tip')
  const { isOpened, handleToggle } = useFoldableSectionHandlers(SectionNames.profile)

  return (
    <SectionContainer>
      <SectionHeader isOpened={isOpened} onClick={handleToggle}>
        <SectionTitle title={title} isOpened={isOpened} />
        <SectionHeaderFoldableContainer isOpened={isOpened}>
          <SectionHint>{hint}</SectionHint>
        </SectionHeaderFoldableContainer>
      </SectionHeader>

      <SectionBodyFoldableContainer isOpened={isOpened}>
        <SectionContent>
          <RichTextArea
            boldButtonDisable
            italicButtonDisable
            linkButtonDisable
            value={fieldValue as string}
            onChange={updateField}
          />
        </SectionContent>
        <SectionHint>{tip}</SectionHint>
      </SectionBodyFoldableContainer>
    </SectionContainer>
  )
}
